import React from "react";
import { useUser } from "../../context/UserContext.js";
import UserDashboard from "./UserDashboard.js";
import SuperAdminDashboard from "./SuperAdminDashboard.js";
import AdminDashboard from "./AdminDashboard.js";
import DashBoardSidebar from "./DashboardSidebar.js";
import "./Dashboard.css";
const Dashboard = () => {
  const { user } = useUser();
  if (user?.type) {
    if (user["type"] === "user") return <UserDashboard />;
    if (user["type"] === "admin") return <AdminDashboard />;
    if (user["type"] === "superadmin") return <SuperAdminDashboard />;
  }
  return (
    <section className="dashboard-container">
      <DashBoardSidebar />
      <div className="main-content">Main content</div>
    </section>
  );
  return <div>Loading</div>;
};

export default Dashboard;
